module.exports = __webpack_public_path__ + "img/DANCINGSHADOWS_HERO.027def74.png";